import React from 'react';
import { METHOD_OPTIONS } from '../paymentsTypes';
import styles from './PaymentFilters.module.css';

interface PaymentFiltersProps {
  search: string;
  onSearchChange: (v: string) => void;
  method: string;
  onMethodChange: (v: string) => void;
  dateFrom: string;
  onDateFromChange: (v: string) => void;
  dateTo: string;
  onDateToChange: (v: string) => void;
}

export const PaymentFilters: React.FC<PaymentFiltersProps> = ({
  search, onSearchChange,
  method, onMethodChange,
  dateFrom, onDateFromChange,
  dateTo, onDateToChange,
}) => {
  return (
    <div className={styles.filtersBar}>
      {/* Search */}
      <div className={styles.searchWrapper}>
        <svg className={styles.searchIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
        </svg>
        <input
          className={styles.searchInput}
          placeholder="Search payments..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      {/* Method dropdown */}
      <div className={styles.selectWrapper}>
        <select
          className={styles.select}
          value={method}
          onChange={(e) => onMethodChange(e.target.value)}
        >
          {METHOD_OPTIONS.map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
        <svg className={styles.chevron} viewBox="0 0 24 24" fill="currentColor">
          <path d="M7 10l5 5 5-5z" />
        </svg>
      </div>

      {/* Date from */}
      <div className={styles.dateWrapper}>
        <input
          type="date"
          className={styles.dateInput}
          value={dateFrom}
          onChange={(e) => onDateFromChange(e.target.value)}
        />
        <svg className={styles.calIcon} viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z" />
        </svg>
      </div>

      {/* Date to */}
      <div className={styles.dateWrapper}>
        <input
          type="date"
          className={styles.dateInput}
          value={dateTo}
          onChange={(e) => onDateToChange(e.target.value)}
        />
        <svg className={styles.calIcon} viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z" />
        </svg>
      </div>
    </div>
  );
};
